import { booleanAttribute, Component, ElementRef, input } from '@angular/core';
import { OpenService } from '@app-services/open.service';
import { MarketPlacePersonalizationUtils } from '@app-components/layouts/shopkeeper-layout/marketplace-personalization';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent {
  readonly loading = input(false, { transform: booleanAttribute });
  readonly small = input(false, { transform: booleanAttribute });

  constructor(
    private openService: OpenService,
    private elRef: ElementRef
  ) {
    this.openService.getLayoutVars().subscribe(result => {
      if (result) {
        MarketPlacePersonalizationUtils.initCssVars(this.elRef, result);
      }
    });
  }
}
